// src/services/InstitucionE.js
import http from './Http';

const listarInstituciones = (filtros = {}) => {
    return http.get('/institucionEdu/', { params: filtros });
};

const crearInstitucion = async (payload) => {
    const response = await http.post('/institucionEdu/', payload);
    return response.data;
};

const InstitucionEService = {
    listarInstituciones,
    crearInstitucion,
};

export default InstitucionEService;
